import { signOutFn } from '@/server/functions/auth'
import { useRouteContext } from '@tanstack/react-router'
import { useServerFn } from '@tanstack/react-start'
import { Models } from 'node-appwrite'

export function useAuth() {
  const context = useRouteContext({ from: '__root__' }) as {
    currentUser?: Models.User<Models.Preferences> | null
  }

  const currentUser = context?.currentUser ?? null
  const signOut = useServerFn(signOutFn)

  return {
    currentUser,
    signOut,
  }
}
